export default {
  Exercise: {
    SelectCorrectAnswer: 'Lựa chọn đáp án',
    SelectCorrectAnswerDescription: 'Chọn vào đây để đánh dấu đáp án đúng cho câu này',
    Title: 'Bài tập',
    ComposeExercise: 'Soạn bài',
    Subject: 'Môn học',
    ComposeHomework: 'Thông tin bài tập',
    UpdateInfo: 'Bổ sung thông tin',
    NewExcercise: 'Soạn mới',
    UploadExercise: 'Tải đề lên',
    GalacticGame: 'Chiến binh thiên hà',
    TimeRemaining: 'Thời hạn còn',
    SubmitStatus: 'Tình trạng nộp',
    Deadline: 'Hạn nộp',
    NameHomework: 'Tên bài tập',
    FilterHomework: 'Thẻ tìm kiếm',
    ExerciseAttach: 'Bài tập đính kèm',
    EditExercise: 'Đã chữa',
    NotSubmitExercise: 'Chưa nộp',
    AllSubject: 'Tất cả môn học',
    AllStatus: 'Tất cả trạng thái',
    MostRecentDeadline: 'Hạn nộp gần nhất',
    GiveExercise: 'Giao bài tập',
    EmptyExercise: 'Chưa có bài tập',
    SaveDraft: 'Lưu nháp',
    GiveExerciseTo: 'Giao bài tập cho',
    TypeExercise: 'Loại bài',
    TypeExerciseDetail: 'Dạng bài   {type}',
    WorkingTime: 'Thời gian làm bài',
    SubmissionList: 'Danh sách học sinh',
    QuestionAnswer: 'Hỏi đáp',
    ExerciseListen: 'Bài nghe',
    ChangeQuestion: 'Đổi loại câu hỏi',
    ExerciseDocument: 'Bài giảng',
    ExerciseOnline: 'Bài online',
    AllExercise: 'Tất cả bài tập',
    Theme: 'Chủ đề',
    Answer: 'Đáp án',
    LibraryHomework: 'Chọn từ thư viện',
    LibraryHomeworkExercise: 'Thư viện bài tập',
    InputAnswer: 'Nhập câu trả lời...',
    DetailExercise: 'Phiếu ôn tập giữa kỳ',
    ExerciseComposed: 'Đã soạn',
    ExerciseDraft: 'Đang soạn',
    SetTimePlayGame: 'Đặt thời gian (giây)',
    DeleteExerciseTitle: 'Xóa bài tập',
    DeleteContentNote: 'Bạn có chắc chắn muốn xóa <b>{entityName}</b> không?',
    EditStopShare:
      'Khi có chỉnh sửa bài tập <b>{entityName}</b> sẽ tự động ngừng chia sẻ.</br>Bạn có muốn tiếp tục?',
    StopShareNote:
      'Bạn có chắc muốn ngừng chia sẻ bài tập <b>{entityName}</b>?',
    DeleteExerciseButton: 'Xóa',
    CancelExercise: 'Không',
    SeeDetails: 'Xem chi tiết',
    ComposeArticles: ' Giao bài',
    GetCollect: 'Sưu tầm',
    EditPost: ' Sửa bài',
    DeletePost: 'Xóa bài',
    NoFoundExercise: 'Chưa có học liệu',
    NoFoundTopics: 'Không tìm thấy chủ đề',
    ViewExercise: 'Xem bài',
    CorrectExercise: 'Chữa bài',
    TheDocument: 'Tài liệu',
    Class: 'Lớp',
    SubjectName: 'Môn học',
    Result: 'Đáp án',
    AttachFile: 'Tài liệu tham khảo',
    SendDate: 'Ngày gửi',
    AfterFinishExercise: 'Gửi ngay sau khi hoàn thành bài', // Ngay sau khi hoàn thành bài
    AfterExpired: 'Gửi sau khi hết hạn nộp', // Sau khi hết hạn nộp
    NoExerciseStore: 'Không tìm thấy học liệu',
    Due: 'Còn hạn',
    Expired: 'Đã hết hạn',
    WaitingGiveExercise: 'Chờ giao',
    MostRecentlySentExercise: 'Gửi gần đây nhất',
    LongestAgoSentExercise: 'Cách đây lâu nhất',
    QuestionsAndAnswers: 'lượt hỏi đáp',
    DayLeft: 'Còn {0} ngày',
    SearchExerciseStore: 'Nhập tên học liệu để tìm kiếm',
    SearchExercise: 'Nhập tên chủ đề, tên học liệu, tác giả,...',
    TeacherTimeOutDay: 'Còn {diffDate} ngày',
    TeacherTimeOutHours: 'Còn {diffDate} giờ',
    DeleteExerciseComfirm: 'Xóa bài tập đã giao',
    ExerciseListEmpty: 'Không tìm thấy bài tập',
    // ttdung1
    LabelLibrary: 'Danh sách câu hỏi đã chọn',
    UseMoreSelectedQuestions:
      'Hướng dẫn sử dụng giỏ bài tập trong màn hình soạn bài giáo viên',
    QuestionAndAnswer: 'Đề bài và lời giải',
    ViewExercisePopup: 'Xem câu đã chọn',
    TextExercisePopup:
      'Nhấn vào đây để xem những câu hỏi đã chọn và thêm vào soạn bài',
    Search: 'Tìm kiếm',
    More: 'Thêm',
    // nvhuy1
    YetSubmit: 'Chưa nộp',
    Submitted: 'Đã nộp',
    // bndung
    PercentExcercise: '{submit}/{total} Bài',
    Correct: 'Đúng',
    False: 'Sai',
    NotDone: 'Chưa làm',
    Done: 'Đã làm',
    Reply: 'Trả lời',
    TheAnswer: 'Lời giải',
    TheAnswerHint: 'Lời giải: {content}',
    TheAnswerHtml:
      '<strong style="width: {width}">Lời giải:</strong> {content}',
    TheQuestion: 'Đề bài',
    ViewDetail: 'Xem chi tiết',
    Note: 'Ghi chú',
    CopyAction: 'Sao chép',
    SeeAndTry: 'Xem & làm thử',
    TryExercise: 'Làm thử',
    Select: 'Chọn đáp án đúng',
    Progress: 'Tiến độ',
    ProgressDetail: '{finishedQuestion}/{totalQuestion} câu',
    Complete: 'Hoàn thành',
    Essay: 'Tự luận',
    EnterNote: 'Nhập vào đây ...',
    ButtonEditQuickly: 'Sửa nhanh',
    EditQuickly: 'Sửa nhanh - Câu {questionCount}',
    notifyEdit:
      'Đáp án bạn chọn khác với đáp án đúng <br> Hãy chọn <strong>Sửa nhanh</strong> nếu muốn thiết lập lại',
    BackCreateExercise: 'Quay về soạn bài',
    Fill: 'Điền từ vào chỗ trống',
    EnterAnswer: 'Nhập câu trả lời',
    ShowAnswer: 'Hiển thị đáp án, lời giải',
    AnswerEassy: 'Đáp án: {Content}',
    ShareExercise: 'Chia sẻ học liệu',
    Practive: 'Luyện tập',
    ChoosedCount: 'Đã chọn {Count}',
    ShareExam: 'Chia sẻ bài kiểm tra',
    ListExerciseChoosed: 'Danh sách học liệu đã chọn ({Count})',
    GradeAndSubject: 'Khối {grade} - {subjectName}',
    ViewMore: 'Xem thêm',
    // vvhung
    QuestionChoice: 'Câu trắc nghiệm',
    QuestionEssay: 'Câu tự luận',
    ListQuestion: 'Danh sách câu',
    AnswerLabel: 'Đáp án',
    AnswerWrited: 'Lời giải',
    AnswerFillLabel: 'Đáp án: ',
    ExerciseDeleted: 'Bạn đã thu hồi bài tập này',
    TheSentence: 'Câu',
    TheSentenceNumber: 'Câu {number}',
    TheNumberQuestionGroup: 'Câu {start} - {end}',
    Draft: 'Đang soạn',
    LibraryExercise: 'Thư viện học liệu',
    SchoolExercise: 'Học liệu trong trường',
    MISAExerciseStore: 'Học liệu tham khảo',
    // nvduc1
    Library: 'Lấy từ thư viện',
    DoneShared: 'Đang chia sẻ',
    NoShared: 'Chưa chia sẻ',
    AllGrade: 'Tất cả các khối',
    AllSubjectExercise: 'Tất cả các môn',
    AllTopic: 'Tất cả các chủ đề',
    AllLibrary: 'Tất cả học liệu',
    DeleteSuccess: 'Bạn đã xóa học liệu thành công',
    SourceEmis: 'Cộng đồng giáo viên',
    // PBac
    StudentAnswer: 'Bài làm',
    DraftExercise: 'Bài nháp {name}',
    PrintFileNameThread: 'DEBAI - {title}',
    Replay: 'Làm lại',
    StopMusic: 'Tắt nhạc',
    PlayMusic: 'Bật nhạc',
    ChooseExerciseTheme: 'Chọn giao diện làm bài',
    ChooseOtherExerciseTheme: 'Chọn giao diện làm bài khác',
    DoExercise: 'Bắt đầu làm bài',
    CloseQuestion: 'Thu gọn câu hỏi',
    OpenQuestion: 'Mở rộng câu hỏi',
    CloseAnswer: 'Thu gọn câu trả lời',
    OpenAnswer: 'Mở rộng câu trả lời',
    ContinueDoExercise: 'Tiếp tục làm bài',
    Leave: 'Rời đi',
    LeaveDoExerciseMessage: 'Bạn có muốn tiếp tục làm bài tập không?',
    CongratFinnishAll: 'Chúc mừng bạn đã hoàn thành tất cả câu hỏi!',
    SubmitNow: 'Nộp bài ngay',
    OrCheckAgain: 'Hoặc kiểm tra lại bài làm',
    HaveQuestionLeft: 'Bạn còn {numberQuestion} câu chưa làm',
    ClickOnUndoneQuestion: 'Nhấn vào câu chưa làm để quay lại làm nốt nhé!',
    Or: 'Hoặc',
    SubmitOnceNotify: 'Lưu ý: Chỉ được nộp một lần duy nhất',
    CompleteNotify: 'Lưu ý: Hệ thống sẽ lưu lại 2 lần làm bài gần nhất',
    CorrectResult: 'Đáp án đúng',
    BackQuestion: 'Câu trước',
    NextQuestion: 'Câu tiếp theo',
    Question: 'Câu ',
    CompleteNow: 'Hoàn thành bài',
    ViewHint: 'Xem lời giải',
    StudentNotSubmit: 'Em <b>{studentName}</b> chưa nộp bài.',
    PractiveExerciseDraft: 'Làm lại bài tập từ đầu sẽ xóa toàn bộ kết quả làm bài trước đó',
    NextQuestionMessage: 'Bạn vừa làm xong câu {currentQuestion}. Mình cùng chuyển sang câu {nextQuestion} nhé!',
    LastQuestionMessage: 'Bạn vừa làm xong câu cuối cùng. Mình cùng soát lại bài nhé!',
    // pqhieu
    LateSubmit: 'Nộp muộn',
    All: 'Tất cả',
    // ttlong
    ResultOverview: 'Tổng quan kết quả',
    Order: 'Hạng',
    StudentName: 'Họ và tên',
    TotalScore: 'Tổng điểm',
    BonusScore: 'Điểm cộng',
    CorrectRate: 'Tỉ lệ làm đúng',
    WorkSpeed: 'Tốc độ làm bài',
    NotRanking: 'Chưa có xếp hạng học sinh làm bài',
    ThemesForYou: 'Học liệu dành cho bạn',
    NewShare: 'Mới chia sẻ',
    ListExerciseFavorite: 'Danh sách yêu thích',
    ExerciseFree: 'Bộ đề miễn phí dành cho bạn',
    ExerciseMostPopular: 'Bộ đề phổ biến nhất dành cho bạn',
    ViewSubject: 'Xem theo môn',
    ActiveTeacherDay: 'Giáo viên trong trường hoạt động tích cực 10 ngày qua',
    TeacherActive: 'Giáo viên tích cực',
    ExerciseLearning: 'Học liệu đã soạn',
    ExerciseShared: 'Học liệu đã chia sẻ',
    ExercisePeopleFavorite: 'Học liệu của bạn có thể chia sẻ',
    ExerciseFavorited: 'Học liệu bạn đã yêu thích',
    ExerciseSharedDay: 'bộ đề đã chia sẻ',
    ViewPageManage: 'Tới trang quản lý',
    Free: 'Miễn phí',
    MostPopular: 'Phổ biến nhất',
    MostPositive: 'Giáo viên tích cực nhất',
    NewTeacher: 'GIÁO VIÊN MỚI',
    TechnologyTeacher: 'GIÁO VIÊN CÔNG NGHỆ',
    PositiveTeacher: 'GIÁO VIÊN TÍCH CỰC',
    CreativeTeacher: 'GIÁO VIÊN SÁNG TẠO',
    Teacher40: 'GIÁO VIÊN 4.0',
    NoteRanking: 'Chia sẻ thêm <b>{numberExercise}</b> học liệu nữa thăng hạng lên <b>{nameRangking}</b>',
    TeacherTopPositive: 'Thầy cô đang nằm trong <b>Top 5%</b> giáo viên tích cực nhất',
    ClickDetail: '(Nhấn xem chi tiết)',
    ExerciseUser: 'Người sử dụng học liệu'

  },
  QuestionType: {
    Yesorno: 'Đúng Sai',
    Group: 'Câu hỏi nhóm',
    Select: 'Chọn đáp án',
    Fill: 'Điền vào chỗ trống',
    Essay: 'Tự luận',
    Pairing: 'Ghép nối'
  },
  Preview: {
    AnswerDetail: 'Lời giải',
    AnswerAndDetail: 'Đáp án và lời giải',
    GiveExcise: 'Giao bài',
    ChangeExercise: 'Chỉnh sửa',
    Library: 'Từ thư viện',
    Share: 'Chia sẻ',
    ShareSchool: 'Trường học',
    Mine: 'Cá nhân',
    MISAStore: 'MISA',
    Refer: 'Tham khảo',
    TeacherCommunity: 'Cộng đồng'
  },
  // Nvduc1

  ExerciseSubmit: 'Kết quả nộp bài',
  MultipleChoice: 'Trắc nghiệm',
  Essay: 'Tự luận',
  Remedy: 'Bài chữa',

  // TTLONG
  ExerciseStore: {
    SelectSharingScope: 'Chọn phạm vi chia sẻ',
    MyPracticeCard: 'Thẻ học liệu của tôi',
    RatingDetail: 'Chi tiết xếp hạng',
    NumberPractice: 'Số lượt sưu tầm học liệu có sẵn <br>trên cộng đồng còn lại',
    SearchResult: 'Tìm thấy {numberResult} kết quả liên quan',
    ShareSchool: 'Chia sẻ trong trường',
    ShareWithTeacherInSchool: 'Chia sẻ riêng với các giáo viên trong trường của bạn',
    ShareWithTeacherInPublic: 'Chia sẻ tới cộng đồng, tất cả mọi người có thể tiếp cận'
  }
}
